module.exports = __webpack_public_path__ + "media/images/infographic-webhook-47bb3a9c0dd910e375586b930fb3a9f5.png";